<template>
  <form class="my-5 mx-5">
    <b-row>
      <b-col cols="6">
        <b-form-group id="name" :label="$t($getConst.pages.scope.name)" label-for="name-input">
          <b-form-input
            id="name-input"
            v-model.trim="$v.scope.name.$model"
            :class="{ 'is-invalid': $v.scope.name.$error || scopeExist }"
            :placeholder="$t(this.$getConst.pages.scope.enter_name)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.name"/>
          <b-form-invalid-feedback v-if="scopeExist">
            {{$t(this.$getConst.pages.form.exist_field_error)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="status" :label="$t($getConst.pages.scope.status)" label-for="status-input">
          <multiselect
            v-model="$v.scope.status.$model"
            :class="{ 'is-invalid': $v.scope.status.$error }"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="status"
            :show-labels="false"
            :searchable="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <b-badge
                class="gradient"
                pill
                :variant="(props.option === 'work' || props.option === 'live') ? 'secondary' : 'warning'"
                style="width:50%;">{{$t($getConst.pages.scope[props.option])}}</b-badge>
            </template>
            <template slot="option" slot-scope="props">
              <b-badge
                class="gradient"
                pill
                :variant="(props.option === 'work' || props.option === 'live') ? 'secondary' : 'warning'"
                style="width:50%;">{{$t($getConst.pages.scope[props.option])}}</b-badge>
            </template>
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.status"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group id="languages" :label="$t($getConst.pages.scope.languages)" label-for="scope-input">
          <multiselect
            v-model="$v.scope.languages.$model"
            :class="{ 'is-invalid': $v.scope.languages.$error }"
            track-by="id"
            label="name"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="languages"
            :multiple="true"
            :show-labels="false"
            :close-on-select="false"
            @input="onChangeLanguages"
          >
            <template slot="option" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name.toLowerCase()) | capitalize}}
            </template>
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.languages"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="default-language" :label="$t($getConst.pages.scope.default_language)" label-for="default-language-input">
          <multiselect
            v-model="$v.scope.language_id.$model"
            :class="{ 'is-invalid': $v.scope.language_id.$error || languageExistInList}"
            track-by="id"
            label="name"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="$v.scope.languages.$model"
            :show-labels="false"
            :searchable="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name) | capitalize}}
            </template>
            <template slot="option" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name.toLowerCase()) | capitalize}}
            </template>
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.language_id"/>
          <b-form-invalid-feedback v-if="languageExistInList">
            {{$t(this.$getConst.pages.form.notAssigned_language_error)}}
          </b-form-invalid-feedback>

        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="nav_scope_id" :label="$t($getConst.pages.scope.nav_scope_id)" label-for="nav_sharedKey-input">
          <b-form-input
            id="nav_scope_id-input"
            v-model.trim="$v.scope.nav_scope_id.$model"
            :class="{ 'is-invalid': $v.scope.nav_scope_id.$error || scope_nav_id_Exist}"
            :placeholder="$t(this.$getConst.pages.scope.enter_nav_scope_id)"
            size="lg"
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.nav_scope_id"/>
          <b-form-invalid-feedback v-if="scope_nav_id_Exist">
            {{$t($getConst.pages.scope.scope_nav_exist)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group id="portal-url" :label="$t($getConst.pages.scope.portal_url)" label-for="portal-url-input">
          <b-form-input
            id="portal-url-input"
            v-model.trim="$v.scope.portal_url.$model"
            :class="{ 'is-invalid': $v.scope.portal_url.$error || portal_url_error }"
            :placeholder="$t(this.$getConst.pages.scope.portal_url)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.portal_url"/>
          <b-form-invalid-feedback v-if="$v.scope.portal_url.$error || portal_url_error">
            {{$t(this.$getConst.pages.form.portal_url_error)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="timezone" :label="$t($getConst.pages.scope.timezone)" label-for="timezone-select">
          <multiselect
                id="timezone-select"
                v-model="$v.scope.timezone.$model"
                :class="{ 'is-invalid': $v.scope.timezone.$error }"
                :placeholder="$t($getConst.pages.form.select_option)"
                :options="timezonesList"
                :show-labels="false"
                :close-on-select="true"
              >
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.timezone"/>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="format_date" :label="$t($getConst.pages.scope.format_date)" label-for="format_date-select">
          <multiselect
            id="format_date-select"
            v-model="$v.scope.format_date.$model"
            :class="{ 'is-invalid': $v.scope.format_date.$error }"
            :placeholder="$t($getConst.pages.form.select_option)"
            :options="formatDate"
            :show-labels="false"
            :close-on-select="true"
          >
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.format_date"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <label>{{ $t($getConst.pages.scope.application_options) }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline" switch v-model="$v.scope.is_timesheets_enabled.$model" size="lg" :disabled="scope.is_timesheets_enabled && !scope.is_invoices_enabled">
          <label>{{$t($getConst.pages.scope.is_timesheets_enabled)}}</label>
        </b-form-checkbox>
      </b-col>

      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline is-invalid" switch v-model="$v.scope.is_invoices_enabled.$model" size="lg" :disabled="scope.is_invoices_enabled && !scope.is_timesheets_enabled">
        </b-form-checkbox>
        <label>
          {{$t($getConst.pages.scope.is_invoices_enabled)}}
        </label>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline" switch v-model="$v.scope.is_freelancers_enabled.$model" size="lg">
          <label>{{$t($getConst.pages.scope.is_freelancers_enabled)}}</label>
        </b-form-checkbox>
      </b-col>

      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline" switch v-model="$v.scope.is_multirole_enabled.$model" size="lg">
          <label>{{$t($getConst.pages.scope.is_multirole_enabled)}}</label>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-1" >
      <b-col cols="6" class="checkbox" >
        <b-form-checkbox    v-model="scope.is_absences_enabled"  switch class="d-inline"  size="lg">
          <label>{{$t($getConst.pages.scope.is_absences_enabled)}}</label>
        </b-form-checkbox>
      </b-col>
      <b-col cols="6" class="checkbox" >
        <b-form-checkbox    v-model="scope.is_absences_per_days"  switch class="d-inline"  size="lg">
          <label>{{$t($getConst.pages.scope.is_absences_per_days)}}</label>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-1" >
      <b-col cols="6" class="checkbox" >
        <b-form-checkbox    v-model="scope.is_worked_hours_validation"  switch class="d-inline"  size="lg">
          <label>{{$t($getConst.pages.scope.is_worked_hours_validation)}}</label>
        </b-form-checkbox>
      </b-col>
      <b-col cols="6" class="checkbox" >
        <b-form-checkbox    v-model="scope.is_limiting_hours_of_work"  switch class="d-inline"  size="lg">
          <label>{{$t($getConst.pages.scope.is_limiting_hours_of_work)}}</label>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row v-if="$v.scope.is_freelancers_enabled.$model" class="mt-2">
      <b-col cols="12">
        <b-form-group id="freelancers_url" :label="$t($getConst.pages.scope.freelancers_url)" label-for="freelancers_url-input">
          <b-form-input
            id="freelancers_url-input"
            v-model.trim="$v.scope.freelancers_url.$model"
            :class="{ 'is-invalid': $v.scope.freelancers_url.$error || freelancers_url_error}"
            :placeholder="$t(this.$getConst.pages.scope.enter_freelancers_url)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.freelancers_url"/>
          <b-form-invalid-feedback v-if="freelancers_url_error || $v.scope.freelancers_url.$error">
            {{$t(this.$getConst.pages.form.freelancers_url_error)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="text-danger" v-if="applicationOptionsError">
      {{ $t($getConst.pages.scope.application_options_error) }}
    </div>

  </form>
</template>

<script>
  import {required, integer, minValue,sameAs, not} from "vuelidate/lib/validators";
  import {addScope, editScope, getTimezonesList} from "../../../api/scopes.api";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import AppSection from "../../../components/common/sections/AppSection";
  import AppSpinner from "../../../components/common/utils/AppSpinner";
  import requiredIf from "vuelidate/lib/validators/requiredIf";

  const matchUrl=(value) =>
    value ?value.split(":")['0'] === "http" ||  value.split(":")['0'] === "https":true;

  export default {
    name: "ScopeForm",
    components: {AppSpinner, AppFormFeedback, AppSection},
    props: {
      modal_id: null,
      scopeToEdit: null,
      languages: null,
    },
    data() {
      return {
        isLoadScope: false,
        isLoading: false,
        newState:null,
        test:null,
        scopeExist: false,
        scope_nav_id_Exist: false,
        languageExistInList: false,
        action: 'add',
        language: null,
        scope: {
          name: null,
          status: null,
          language_id: null,
          nav_scope_id: null,
          portal_url: null,
          languages: [],
          is_timesheets_enabled: true,
          is_invoices_enabled: false,
          is_multirole_enabled: false,
          timezone: '',
          format_date:'',
          is_freelancers_enabled: false,
          freelancers_url: '',
          is_absences_enabled : false,
          is_absences_per_days : false,
          is_worked_hours_validation : false,
          is_limiting_hours_of_work : false,
        },
        scopeLanguages: [],
        status: [this.$getConst.pages.scope.live, this.$getConst.pages.scope.maintenance],
        isSubmited: false,
        listOfLanguages: this.languages,
        timezonesList: [],
        formatDate: [],
        applicationOptionsError: false,
        portal_url_error: false,
        freelancers_url_error : false,
      }
    },

    validations: {
      scope: {
        name: {required},
        status: {required},
        language_id: {required},
        nav_scope_id: {required: requiredIf(function(){
            return this.scope.is_timesheets_enabled
          }), integer, minValue: minValue(1)},
        languages: {required},
        is_timesheets_enabled: {required},
        is_invoices_enabled: {required},
        is_multirole_enabled: {required},
        is_absences_enabled:{required},
        portal_url: {required, matchUrl ,checkUrl : not(sameAs('freelancers_url'))},
        timezone: {required},
        format_date: {required},
        is_freelancers_enabled: {required},
        freelancers_url: {
          required: requiredIf(function () {
            return this.scope.is_freelancers_enabled
          }), matchUrl ,checkUrl : not(sameAs('portal_url'))
        }
      },
    },
    created() {
      if (this.scopeToEdit) {
        this.action = 'edit';
        this.scope = this.scopeToEdit;
      }
      this.getTimezonesListData();
      this.formatDate = ['MM/DD/YYYY', 'DD/MM/YYYY']
    },
    mounted() {
      this.$root.$on('isSubmited', submit => {
        this.isSubmited = submit;
      });
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.modal_id)
      },
      updateScope() {
        let scope = Object.assign({}, this.scope);
        scope.language_id = this.scope.language_id.id;
        scope.languages = this.scope.languages.map(language => {
          return language.id;
        });
        return scope;
      },
      isFormInvalid() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return true;
        }
        return false
      },
      errorFromServerTreatment(error){
        if (error.response.data.code === 422) {
          this.scopeExist = 'name' in error.response.data.error;
          this.scope_nav_id_Exist = ('nav_scope_id' in error.response.data.error)&&(error.response.data.error.nav_scope_id[0]==="validation.unique");
          this.languageExistInList = 'default_language' in error.response.data.error;
          this.applicationOptionsError = 'is_timesheets_enabled' in error.response.data.error || 'is_invoices_enabled' in error.response.data.error;
          this.portal_url_error= 'portal_url' in error.response.data.error;
          this.freelancers_url_error= 'freelancers_url' in error.response.data.error;
        }
        this.$root.$emit('isLoading', false);
        this.isSubmited = false;
      },
      formValidTreatment() {
        this.$root.$emit('isLoading', true);
        this.scopeExist = false;
        this.scope_nav_id_Exist = false;
        this.applicationOptionsError = false;
      },
      addScope() {
        if (this.isFormInvalid()) {
          return;
        }
        this.formValidTreatment();
        addScope(this.updateScope()).then(
          res => {
            this.$root.$emit('onAddScope', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            this.errorFromServerTreatment(error);
          }
        )
      },
      editScope() {
        if (this.isFormInvalid()) {
          return;
        }
        this.formValidTreatment();
        editScope(this.scopeToEdit.id, this.updateScope()).then(
          res => {
            if (res.data.id == this.$store.getters["auth/scopeDefault"].id) {
              this.newState = JSON.parse(localStorage.getItem("userAccount"));
              this.newState.scopeDefault = res.data;
              localStorage.setItem("userAccount", JSON.stringify(this.newState));
              this.$store.dispatch("auth/setUserAccountAction", this.newState);
            }
            this.$root.$emit('onEditScope', res.data);
            this.$root.$emit('isLoading', false);
            this.closeModal();

          },
          error => {
           this.errorFromServerTreatment(error);
          }
        )
      },
      onChangeLanguages() {
        if (!this.scope.languages.includes(this.scope.language_id)) {
          this.scope.language_id = null;
        }
      },
      getTimezonesListData() {
        getTimezonesList().then(
          res => {
            this.timezonesList = res.data
          }
        );
      }
    },
    watch: {
      isSubmited: function () {
        if(this.isSubmited) {
          if (this.scopeToEdit) {
            this.editScope();
          } else {
            this.addScope();
          }
        }

      }
    }
  }
</script>

<style scoped>
  .checkbox {
        padding: 1%;
  }
</style>
